import { useMemo } from 'react';
import { useURLSearchParams } from '~/modules/common/hooks/useURLSearchParams';

export const useTaskBeatSearchParamTaskFilter = () => {
  const searchParams = useURLSearchParams();

  const taskId = searchParams.get('task');

  const taskFilter = useMemo(() => (taskId ? { taskUris: [taskId] } : {}), [
    taskId
  ]);

  return taskFilter;
};

export default useTaskBeatSearchParamTaskFilter;
